<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ {{ order_head.order_code }}</b></div>
            <div v-if="order_head.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>
            <div v-else-if="order_head.status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #fdac39">ดำเนินการ</b></div>
            <div v-else-if="order_head.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">เสร็จสิ้น</b></div>
            <div v-else-if="order_head.status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #eb5c5d">ยกเลิก</b></div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกค้า</b> <span v-if="order_head.tax_invoice !== 0" style="color: #8CC63E;">(รับใบกำกับภาษี)</span></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อลูกค้า : </div>
              <div class="ml-1 mr-3">{{ order_head.name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ที่อยู่จัดส่ง : </div>
              <div v-if="order_head.payment_type !== 3" class="ml-1 mr-3">{{ order_head.delivery_address }}</div>
              <div v-else class="ml-1 mr-3">รับที่ร้านฟาร์มาแคร์ พลัส (สำนักงานใหญ่)</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="order_head.telephone !== null" class="ml-1 mr-3">{{ order_head.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การชำระเงิน</b></div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div v-if="order_head.payment_type === 1" class="ml-1 mr-3">โอนเงิน</div>
                  <div v-else-if="order_head.payment_type === 2" class="ml-1 mr-3">ติดเครดิต</div>
                  <div v-else-if="order_head.payment_type === 3" class="ml-1 mr-3">รับสินค้าหน้าร้าน</div>
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <div class="ml-1 mr-3">{{ format_price(order_number) }} บาท</div>
                </div>
                <div class="mt-2" style="color: #8cc63e">
                  <div>ผ่านการตรวจสอบการชำระเงินแล้ว</div>
                  <div class="grid_flex">
                    <div class="mr-2">ผู้ตรวจสอบ :</div>
                    <div class="">{{ order_head.user_confirm_name }} {{ order_head.confirm_date }}</div>
                  </div>
                </div>
              </div>
              <div class="mx-auto">
                <v-img v-if="slip_img.slip_picture !== null" @click="show_img()" class="mx-auto rounded cursor_img"  max-width="160" :lazy-src="picture_not_found" :src="slip_img.slip_picture"></v-img>
                <v-img v-else class="mx-auto rounded cursor_img" max-width="160" :lazy-src="picture_not_found" :src="picture_not_found"></v-img>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider/>
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage" hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table">
                      <div class="mx-auto">
                        <v-img class="rounded mx-auto" v-if="dataDetail.item.product_picture !== null" height="120" width="120" max-width="120" :lazy-src="picture_product" :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="rounded mx-auto" v-else height="120" width="120" max-width="120" :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div><b>{{ dataDetail.item.product_name }}</b></div>
                      <div v-if="dataDetail.item.product_list !== null">
                        <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                          <small class="pl-3">- {{ data.name }} ({{ data.qty }} {{ data.unit_name }})</small>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.cost) }}</td>
                    <td class="border_table text-center">{{ format_number(dataDetail.item.qty) }} {{ dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td class="border_table text-center"><b>{{ format_price(order_head.delivery_price) }}</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td class="border_table text-center"><b>{{ format_price((total + parseFloat(order_head.delivery_price))) }}</b></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
        <div class="text-center pa-5 mb-3">
          <v-btn large elevation="5" @click="order_edit" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
            <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
          </v-btn>
          <v-btn large elevation="5" @click="print_send_order" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
            <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
          </v-btn>
          <v-btn v-if="order_head.tax_invoice === 0" large elevation="5" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-grey-bg white--text rounded-pill" disabled>
            <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
          </v-btn>
          <v-btn v-else-if="order_head.tax_invoice === 1" large elevation="5" @click="print_tax_invoice" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
            <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
          </v-btn>
<!--          <v-btn large elevation="5" @click="cancel_order = true" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-danger-bg white&#45;&#45;text rounded-pill">-->
<!--            <v-icon>mdi-window-close</v-icon> ยกเลิกคำสั่งซื้อ-->
<!--          </v-btn>-->
        </div>
      </div>
      <v-dialog v-model="cancel_order" max-width="700">
        <v-card>
          <v-form ref="cancel" @submit.prevent="save_cancel">
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยกเลิกคำสั่งซื้อ
              </v-card-title>
              <v-btn icon class="ma-4" @click="cancel_order = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="mb-5" style="font-size: 20px">คุณต้องการยกเลิกคำสั่งซื้อของลูกค้าเพราะเหตุใด ?</div>
                <v-text-field color="#86bc3a" label="กรุณากรอกเหตุผลการยกเลิกออเดอร์" v-model="send_data.cancel_note" :rules="[v => !!v || 'กรุณากรอกเหตุผลการยกเลิกออเดอร์']" hide-details="auto" outlined></v-text-field>
              </div>
              <div class="text-center mt-4">
                <v-btn x-large type="submit" class="rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="preview_modal" max-width="512">
        <div v-if="loading_img === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else>
          <v-card>
            <v-form ref="cancel" @submit.prevent="save_cancel">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  หลักฐานการชำระเงิน
                </v-card-title>
                <v-btn icon class="ma-4" @click="preview_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-1" v-for="(data, index) in (this.slip_sub_img)" :key="index">
                  <v-img max-width="360" v-if="data.slip_picture !== null" :lazy-src="picture_holder" :src="data.slip_picture" class="mx-auto rounded"></v-img>
                  <v-img max-width="360" v-else :lazy-src="picture_holder" :src="picture_holder" class="mx-auto"></v-img>
                  <div class="text-center mt-2" style="color: #8cc63e">ผู้อัพโหลด : {{ data.from }}</div>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_not_found from "@/assets/image-not-found.png";
import picture_product from "@/assets/pill.png";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Confirm_order_detail",
  data() {
    return {
      loading_page: false,
      loading_img: false,
      picture_holder: picture_holder,
      picture_not_found: picture_not_found,
      picture_product: picture_product,
      perPage: -1,
      image_modal: false,
      preview_modal: false,
      cancel_order: false,
      order_number: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      send_data: {
        cancel_note: '',
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      order_head: [],
      slip_img: [],
      slip_sub_img: [],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    save_cancel() {
      if (this.$refs.cancel.validate()) {
        Swal.fire({
          title: 'ต้องการยกเลิกคำสั่งซื้อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.$router.push('/sell/orderretailcustomers')
          }
          else {
            this.send_data.cancel_note = ''
          }
        })
      }
    },
    get_data() {
      this.data_list = []
      this.loading_page = true
      HTTP.post('sell/correctslip', {
        order_id: this.$route.params.id,
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.order_head = res.data.object.order_head
          if (res.data.object.order_head.total !== null && res.data.object.order_head.total !== 'undefined') {
            this.order_number = res.data.object.order_head.total
          }
          else {
            this.order_number = 0
          }
          res.data.object.order_lists.forEach((data) => {
            this.data_list.push({
              barcode: data.barcode,
              id: data.id,
              lot_no: data.lot_no,
              order_id: data.order_id,
              product_list: data.product_list,
              product_id: data.product_id,
              product_name: data.product_name,
              product_picture: data.product_picture,
              promotion_exp_id: data.promotion_exp_id,
              promotion_main: data.promotion_main,
              promotion_set_id: data.promotion_set_id,
              unit_name: data.unit_name,
              qty: data.qty,
              cost: data.cost,
              status: data.status,
              total: data.total,
              unit_id: data.unit_id,
            })
          })
          this.slip_img = res.data.object.slips[0]
        }
      })
    },
    show_img() {
      this.preview_modal = true
      this.loading_img = true
      HTTP.post('sell/slips', {
        order_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_img = false
          this.slip_sub_img = res.data.object
        }
      })
    },
    order_edit() {
      const id = this.$route.params.id
      this.$router.push('/sell/orderretailedit/' + id)
    },
    print_send_order() {
      if (this.order_head.payment_type !== 3) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpay/' + this.order_head.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslip/' + this.order_head.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/envelope/' + this.order_head.order_code, '_blank')
      }
      else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpay/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslip/' + this.order_header.order_code, '_blank')
      }
    },
    print_tax_invoice() {
      window.open('https://www.pharmacare-plus.com/taxinvoice/' + this.order_head.order_code, '_blank')
    }
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        let total_price = number.cost * number.qty
        if (total_price < 0) {
          return sum+(0)
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result;
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.cursor_img {
  cursor: pointer;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.mobile_grid {
  width: 25%
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 32%
  }
}
@media only screen and (max-width: 500px) {
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>
